import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";
@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.css']
})
export class NewsDetailComponent implements OnInit {
  news:any=[];
  SingleNews:any
  constructor(private router: Router , 
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService) {
    }
  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.getDetails();
    this.getSingleDetails(id)
  }

  newsDetails(id:any){
    // window.location.reload();
    // this.router.navigateByUrl("news-detail/" + id);
    this.getSingleDetails(id);

  }
  getSingleDetails(id:any) {
    const url = this.global.basePath + "news/detail?id=" + id;
    this.global.GetRequestUnauthorised(url).subscribe((res:any) => {
      console.log("🚀 ~ file: archers.component.ts ~ line 30 ~ ArchersComponent ~ this.global.GetRequest ~ res", res)
      const data = res[0].json.data;
      this.SingleNews = data;
    });
  }

  getDetails() {
    const url = this.global.basePath + "news";
    this.global.GetRequestUnauthorised(url).subscribe((res:any) => {
      console.log("🚀 ~ file: archers.component.ts ~ line 30 ~ ArchersComponent ~ this.global.GetRequest ~ res", res)
      const data = res[0].json.data;
      this.news = data;
    });
  }

}
